import React from "react";
import {getCustomBrandingLogo, H1} from "@reside/ui";
import {connect} from "react-redux";
import {Dispatch} from "../../store";

import {PreviewPageVerifyAnswersProps} from "../page-admin-organizations-branding/atoms/Preview/types";
import {DEFAULT_LOGO_URL} from "../page-admin-organizations-branding/constants";
import {Layout, HeaderContainer, FormBoxWrapper} from "./styles";
import {CustomLogo} from "../../atoms/custom-logo/CustomLogo";
import {VerifyAnswersForm} from "./atoms/verify-answers-form";
import {IconButton} from "../../atoms/icon-button";

type DispatchProps = Readonly<{
  setToken: (token: string) => void;
  onLogout: () => void;
}>;

export const PageAdmissionVerifyAnswersRenderer = ({
  setToken,
  onLogout,
  logoutOnUnauthorized = true,
  logoUrl = DEFAULT_LOGO_URL,
}: DispatchProps & PreviewPageVerifyAnswersProps) => {
  const isResidentExperience = window.location.pathname.includes("/admission/");
  const displayLogoUrl = isResidentExperience
    ? getCustomBrandingLogo(logoUrl)
    : logoUrl;

  return (
    <Layout id="verify-answers">
      <HeaderContainer>
        <CustomLogo src={displayLogoUrl} alt="Company logo" />
        <H1 fontSize={[6]} lineHeight={["40px", "32px", "64px"]}>
          Welcome to the Reside Resident Experience
        </H1>
      </HeaderContainer>

      <FormBoxWrapper>
        <VerifyAnswersForm
          onVerified={setToken}
          onUnauthorized={logoutOnUnauthorized ? onLogout : () => {}}
        />
      </FormBoxWrapper>

      <footer>
        <IconButton
          testId="exit-button"
          background="white"
          iconName="house"
          onClick={onLogout}
        >
          Exit
        </IconButton>
      </footer>
    </Layout>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setToken: dispatch.admissionSession.setToken,
  onLogout: dispatch.admissionSession.logout,
});

export const PageAdmissionVerifyAnswers = connect(
  null,
  mapDispatchToProps,
)(PageAdmissionVerifyAnswersRenderer);
